export function WhyChooseUs() {
  const values = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Local Expertise',
      description: 'Three generations of deep knowledge about St. Pete Beach and Gulf Coast properties, market trends, and community insights.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Client-Focused Approach',
      description: 'We coordinate the mutual desires of buyers, sellers, landlords, and renters with personalized attention and care.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Proven Results',
      description: 'Decades of successful transactions and satisfied clients across real estate sales, rentals, and property management.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Professional Integrity',
      description: 'Licensed realtors with a strong sense of responsibility, using the latest technologies and interpersonal skills.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose Hurley Associates
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experience, reliability, and local knowledge serving the beaches for three generations
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${value.icon} text-3xl text-white w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}